import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/questionnaires');

const QuestionnairesFxs = {
    getQuestionnaireFx: domain.effect(api.questionnaires.getQuestionnaire),
    getDocumentTypesFx: domain.effect(api.questionnaires.getDocumentTypes),
    getQTypesFx: domain.effect(api.questionnaires.getQTypes),
};

export default QuestionnairesFxs;
